import { number } from 'echarts/lib/export';
import * as office from '../../../../../../static/webOffice/iWebOffice2015.js'  //注意路径 

export default{ 
    data() {
        return {  
            apis:{//接口列表 
                upload: this.$global.baseUrl + 'sh/file/upload',//文件上传    
                bykey:'oa/official/sendDoc/byKey',//详情
                tempList:'oa/fileTemp/list',
                byTempKey: 'oa/fileTemp/byKey',//主键查找
                getTrackByBiz: '/oa/official/getTrackByBiz' //获取流程轨迹
            }, 
            WebOfficeStr:'',
            detectOSFlag:'',
            WebOffice:null,  
            oxc:null,
            editObj:{}, 
            nType:1,
            dialogTableVisible:false,
            params:{
                page:1,
                limit:9999
            }, 
            tempData:[],
            pointer:{
                'cursor':'pointer'
            }, 
            winDialog:null,
            png2:"hex:89504E470D0A1A0A0000000D4948445200000018000000180806000000E0773DF8000000097048597300000B1200000B1201D2DD7EFC00000122494441544889ED95BD4AC35018869F98C645842A1497CECE422797A290730552C824F5127A25E7120A5D1208DE408EA064C91470EAE05010BA8883A368A59F4B23A50D6D6C9A0EE23B9D9FEFBC0F7C2FE71C4B44A8527B95BAEF0250CB064AA9ADF6CA18630120228808AEEBCAA27CDF5F5A2B5233F34244FE4006FF80B5AAAD2B0882A03A80E779457D9C85F9A410A0A06C601AA6B106E8B4DABD288AEC6D016C603A484C3F190DBB00EF9F1FF5EB73759315940979C91C20190DBB83C4F4CB029C3CF33CC8C62D0AD358E799CF438E0F0E9FADECC3514A8931A6A8BF037C013CBD8C2FF4DDEDFDFC66CFBDBA3C3D693EC0E62D9A00859EF7DDDE64A5D4AF0E6BADD96FD457D6FC645046611AEBF1DBEB1940F3A8F1D869B57B5B05AC52E5197C03B5E7B70EA44B70540000000049454E44AE426082",
            png10:"hex:89504E470D0A1A0A0000000D4948445200000018000000180806000000E0773DF8000000097048597300000EC300000EC301C76FA8640000008649444154488963FCFFFF3F032D01134D4DA787052C3046505010D6B05AB76E1D23552C6060606058DEA38A2279E0B613435050D07F4A2C61C127E9A0BA8F81213D1DA7EFF00198A3F05A00B3C401CD67844064C96D387B18A52206060686BE9502B4B5A028FC03550C8D3C8D600FFD3818B560D4822160014A4E462E05A90518472B7D420000777A20E5FDFD46920000000049454E44AE426082"
	
        }
    },
    props:{ 
        show:false,//是否显示轨迹抽屉
        bizKey:null,//业务主键 
        fileId:null,//文件主键,
        fileType:null,//文件类型
        bizType:null,//业务类型
        isView:{
            type:Number,
            default:0
        }
    },
    mounted() {  
       window.selectTemp=this.selectTemp;
    },                     
    methods: {   
        init(){     
            this.WebOfficeStr=office.LoadStr();
            this.detectOSFlag = office.detectOS();  
            console.log("控件str:" +  this.WebOfficeStr); //获取控件Str
            console.log("系统类型：" + this.detectOSFlag); //获取当前系统环境是win 还是 linux  
            this.initType();
            
        },
        openLocal(){
            this.WebOffice.WebOpenLocal();
        },
        saveLocalFile(){

            var ret = this.WebOffice.WebSaveLocal();
        },
        initType(){
            if(this.fileType){
                if(this.fileType==".doc"||this.fileType==".docx"||this.fileType==".wps"){
                    this.nType=1;
                }
                if(this.fileType==".xls"||this.fileType==".xlsx"||this.fileType==".et"){
                    this.nType=12;
                }
                if(this.fileType==".ofd"){
                    this.nType=3;
                }
            } 
            this.load(); 
        },
        find(){
            const me=this;
            me.$post({
                url: me.apis.bykey,
                params: {
                    key:me.key, 
                }
            }).then(rsp => {
                if(rsp.success){
                    me.editObj=rsp.retObj; 
                    me.fileId=me.editObj.fileId;
                    me.load();
                }
            })
        },
        load(){ 
            document.getElementById('object').innerHTML = this.WebOfficeStr; 
            this.detectOSFlag != 'isWin' ? this.load_XC() : this.load_Win();
        },
        load_Win(){ 
            this.ocx = document.getElementById("WebOffice2015");  
            this.WebOffice = document.getElementById("WebOffice2015").FuncExtModule;   
            this.WebOffice.HookEnabled=false;     
            this.WebOffice.ShowToolBar=false;  
            // this.WebOffice.AppendMenu("1","打开本地文件(&L)", this.png10);
            // this.WebOffice.AppendMenu("2","保存本地文件(&S)", this.png2);  
            this.WebOffice.WebUrl=this.$global.baseUrl +"oa/official/file"; 
            this.WebOffice.RecordID=this.fileId;   
            this.WebOffice.Template="";  
            this.WebOffice.FileName="";   
            this.WebOffice.FileType=this.fileType;  
            this.WebOffice.UserName=sessionStorage.getItem(this.$global.userName);  
            this.WebOffice.EditType='1,1';     
            this.WebOffice.WebSetMsgByName("bizKey",this.bizKey);  
            this.LoadDocument();  
        },
        load_XC(){   
            this.WebOffice = document.getElementById("WebOffice");  
            if (! this.WebOffice.setPluginType(this.nType))     //自主可控默认加载WPS插件
            {
                this.$message.error("setPluginType fail 1");
                this.$message.error( this.WebOffice.GetErrMessage());
                return;
            }
            this.WebOffice.WebUrl=this.$global.baseUrl +"oa/official/file";  
            this.WebOffice.RecordID=this.fileId;  
            
            this.WebOffice.Template="";  
            this.WebOffice.FileName="";   
            this.WebOffice.FileType=this.fileType;  
            this.WebOffice.UserName=sessionStorage.getItem(this.$global.userName);  
            this.WebOffice.EditType='1,1';     
            this.WebOffice.WebSetMsgByName("bizKey",this.bizKey); 
            this.LoadDocument();  
        },
        LoadDocument(){  
            if (!this.WebOffice.WebOpen()) {   
                return false;
            }  
        
        },
        saveFile(){  
            if( this.detectOSFlag == 'isWin'){ 
                this.ocx.Http.SetRequestHeader("Content-Type","application/octet-stream");
            }
            if (!this.WebOffice.WebSave()) {    
                return false;
            } else {
                if (this.detectOSFlag == 'isWin') {
                    this.ocx.Hide(0);
                    this.ocx.HidePlugin(0);
                } else {
                   // this.WebOffice.Hide(0);
                   // this.WebOffice.HidePlugin(0);
                }
               this.$emit('callback', this.WebOffice.WebGetMsgByName("fileKey")); 
            }
        },
        toClose(){
            if(this.isView==0){  
                if(this.WebOffice){ 
                    this.saveFile(); 
                } else {
                    if (this.detectOSFlag == 'isWin') {
                        this.ocx.Hide(0);
                        this.ocx.HidePlugin(0);
                    } else {
                       // this.WebOffice.Hide(0);
                        //this.WebOffice.HidePlugin(0);
                    }
                     this.$emit('close', null, this);  
                }
            }else{
                if (this.detectOSFlag == 'isWin') {
                    this.ocx.Hide(0);
                    this.ocx.HidePlugin(0);
                } else {
                   // this.WebOffice.Hide(0);
                    //this.WebOffice.HidePlugin(0);
                }
                this.$emit('close', null, this); 
            }
            
            this.WebOffice=null;
        },
        showRevision(value){ 
            if(value){
                this.WebOffice.WebShow(true);
                this.WebOffice.setScreenFocus();      //设置焦点到文档中
            }else{
                this.WebOffice.WebShow(false);
                this.WebOffice.setScreenFocus();
            }
        },
        WebOpenPrint(){ 
            var falg = this.WebOffice.WebOpenPrint();
        }, 
        chooseTemp(){
            let {href}  = this.$router.resolve({ path: "/oa/fileTemp/choose/"+this.bizType})  
             
            this.winDialog=window.open(href,"_blank","height=500, width=700, top=300, toolbar=no, menubar=no, scrollbars=no, resizable=no,location=no, status=no,left=300");
            // const me=this;
            // me.params.bizType=me.bizType;
            // me.$post({
            //     url: me.apis.tempList,
            //     params: me.params
            // }).then(rsp => { 
            //     me.tempData=rsp.retList;
            //     me.dialogTableVisible=true;
            // })
            
        }, 
        selectTemp(row){   
            this.winDialog.close();
            this.dialogTableVisible=false;
            if( this.detectOSFlag == 'isWin'){ 
                this.ocx.Http.SetRequestHeader("Content-Type","application/octet-stream");
            }
            if (!this.WebOffice.WebSave()) {    
                return false;
            } else{ 
                this.WebOffice.RecordID=this.WebOffice.WebGetMsgByName("fileKey");  
            }
            this.WebOffice.WebSetMsgByName("COMMAND", "INSERTFILE");
            this.WebOffice.Template=row.id; 
            this.WebOffice.EditType="1,1";   
            if (this.WebOffice.WebLoadTemplate()){ 
                if(!this.WebOffice.WebInsertFile()){
                    return false;
                }else{
                    this.dialogTableVisible=false;
                }
                 
            }  
        },
        sign(){  
             this.WebOffice.WebOpenSignature();
        },
        leaderOpinion(){
            this.$post({
                url: this.apis.getTrackByBiz,
                params: this.bizKey
            }).then(rsp => {
                if (rsp.success) {
                   let tracks = rsp.retList; 
                    tracks.forEach((item,index) => {  
                        if (item.hasRoles.indexOf("签发")>=0){ 
                            if (item.userInfo.signature){ 

                                this.WebOffice.WebObject.Application.Selection.Range.InsertAfter("                                                          " + this.$moment(item.finishTime).format("YYYY/MM/DD")+"\n");  
                                this.WebOffice.WebSetMsgByName("NEWNAME", item.userInfo.signature);
                                this.WebOffice.WebInsertImage("Image", item.userInfo.signature, true, 1);   //交互OfficeServer的OPTION="INSERTIMAGE"  参数1表示标签名称  参数2表示图片文件名  参数3为true透明  false表示不透明  参数4为4表示浮于文字上方  5表示衬于文字下方
                                this.WebOffice.WebObject.Application.Selection.Range.InsertAfter(item.opinion + "\n");  
                            }else{  
                                this.WebOffice.WebObject.Application.Selection.Range.InsertAfter("                                                          " + this.$moment(item.finishTime).format("YYYY/MM/DD") + "\n"); 
                                this.WebOffice.WebObject.Application.Selection.Range.InsertAfter("                                                          " + item.userName + "\n");
                                this.WebOffice.WebObject.Application.Selection.Range.InsertAfter(item.opinion + "\n");   
                            }
                            
                              //下面方法老OA2003版插件使用,新版本插件调用失败后找到解决方案,上面如存在问题可使用下面方式(未完成)
                                // var myRange = this.WebOffice.WebObject.Application.ActiveDocument.Paragraphs(1).Range;
                                // myRange.ParagraphFormat.Alignment = 2;
                                // myRange = webform.WebOffice.WebObject.Range(0, 0);
                                // myRange = this.WebOffice.WebObject.Application.ActiveDocument.Range(0, 0);
                                // myRange.Select();
                        }
                    });
                    
                   
                }
            })
        }
    },
}


// WEBPACK FOOTER //
// ./src/components/oa/view/webOffice/src/edit.js